<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="dedication"><a id="page_5"></a><em>Dedication</em></h2>
<p class="noindent"><strong>I</strong> dedicate this book to the Masters and Teachers and the Lords of Akasha. I want to thank them for the constant inspiration and guidance they give me in my life.</p>
<p class="indent">Also, to each student who has shared so deeply with me in the workshops and intensives we’ve experienced together. This book is an outpouring of the knowledge and experience I have gained from my work with you. You all have been and continue to be an inspiration to me. Your stories and personal breakthroughs have been my primary motivations to continue teaching this material.</p>
<p class="indent">And finally, to my family and children, for all of their support and for putting up with me and with my crazy travel schedule.<a id="page_6"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2de3be9a